import { FC, useEffect } from "react";

import { AnalyticsEvent } from "@repo/edtech-analytics";
import { getApiUrl } from "@repo/edtech-api";
import { ParsedHtmlView, SanitizeOptionsMode } from "@repo/edtech-ui-kit";
import clsx from "clsx";

import { TrackFn } from '../../../../model';
import { getConfig } from "../../../../origins";

import st from "./Longread.module.scss";

type Props = {
  description: string,
  onFinishLesson: TrackFn,
  className?: string,
};

export const Longread: FC<Props> = ({
  description,
  onFinishLesson,
  className,
}) => {
  const { isImageWithModal, ignoreImageHeight } = getConfig();

  useEffect(() => {
    onFinishLesson(
      { type: AnalyticsEvent.Completed }, true, true,
    );
  }, [ onFinishLesson ]);

  return (
    <div className={clsx(st.longread, className)}>
      <ParsedHtmlView
        className={st.parsed_html}
        enableImageModal={isImageWithModal}
        html={description}
        ignoreImageHeight={ignoreImageHeight}
        imgSrcPrefix={getApiUrl() as string}
        mode={SanitizeOptionsMode.html}
        useStyles={true}
      />
    </div>
  );
};
